import _find from 'lodash/find';
import accedoOne from '@accedo/accedo-one';
import config from '../../config';

// TODO: Extract and get from server
const APP_KEY = config.accedoOneSdk.appKey;
const client = accedoOne({
  appKey: APP_KEY,
});

function loadImage(url) {
  return new Promise(resolve => {
    // eslint-disable-next-line
    const img = new Image();
    img.onload = () => resolve(img);
    img.src = url;
  });
}

export const getPromos = cb => {
  let meta;

  const loadContainerEntry = metadata => {
    meta = metadata;
    return client.getEntryById(meta.promoCarousel, {
      preview: metadata.previewMode,
    });
  };

  const loadPromoEntries = carouselContainer => {
    if (carouselContainer.carouselRotation) {
      // Load all entries
      return client
        .getEntries({
          id: carouselContainer.promoCarousel,
          preview: meta.previewMode,
        })
        .then(response => {
          return {
            entries: response.entries,
            meta,
            carouselContainer,
          };
        });
    }
    // Load a single entry
    const max = carouselContainer.promoCarousel.length;
    const randomEntryIndex = Math.floor(Math.random() * max);
    return client
      .getEntryById(carouselContainer.promoCarousel[randomEntryIndex], {
        preview: meta.previewMode,
      })
      .then(entry => ({ entries: [entry], carouselContainer, meta }));
  };

  const loadPromoImages = entriesResponse => {
    Promise.all(
      entriesResponse.entries.map(entry => loadImage(entry.bannerImage.fileUrl))
    ).then(loadedImages => {
      cb(null, {
        ...entriesResponse,
        // Map the loaded image to its entry
        entries: entriesResponse.entries.map(entry => {
          return {
            ...entry,
            loadedImageEl: _find(
              loadedImages,
              image => image.src === entry.bannerImage.fileUrl
            ),
          };
        }),
      });
    });
  };

  client
    .getAllMetadata()
    .then(loadContainerEntry)
    .then(loadPromoEntries)
    .then(loadPromoImages)
    .catch(err => {
      cb(err);
    });
};

export const fetchPrivacyPolicy = () => {
  return client.getEntryByAlias('privacy-policy');
};



// WEBPACK FOOTER //
// ./src/client/src/apps/login/api-sdk.js